module.exports = __webpack_public_path__ + "img/t2-13.520afe66.jpg";